"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Legend = _interopRequireDefault(require("./Legend"));

var _utils = require("../../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

/**
 * An image legend is an object that is responsible for displaying and managing multiple related
 * legends within a single view along with title labels for each as required.
 *
 * @export
 * @class ImageLegend
 * @implements {ILegendRenderable}
 */
var ImageLegend =
/** @class */
function (_super) {
  __extends(ImageLegend, _super);

  function ImageLegend() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this._load = (0, _utils.debounce)(function (url) {
      if (!url) {
        var error = new Error('Invalid legend url');

        _this.trigger('load:error', {
          error: error
        });

        _this.$el.hide();

        return;
      }

      if (!_this._image) {
        _this._image = new Image();
      }

      _this.trigger('load:start');

      _this._image.onload = function () {
        var units = _this.units();

        var title = _this.opts.title ? _this.opts.title.replace(/\([^\)]+\)$/, "" + (units ? "(" + units + ")" : '')) : null;

        _this.$el.html("\n\t\t\t\t" + (_this.opts.title ? "<div class=\"awxjs__legend-title\">" + title + "</div>" : '') + "\n\t\t\t\t<div class=\"awxjs__legend-content\"><img src=\"" + url + "\"></div>\n\t\t\t"); // this.$el.show();


        _this.trigger('load:done');

        setTimeout(function () {
          var size = _this.getSize();

          size.width = Math.max(size.width, _this._image.width);

          _this.$el.css('width', size.width + "px");

          _this.trigger('resize', size);
        }, 150);
      };

      _this._image.onerror = function () {
        console.warn("[Aeris] ImageLegend - Failed to load image from " + url);
      };

      _this._image.src = url;
    }, 250);
    return _this;
  }

  Object.defineProperty(ImageLegend.prototype, "image", {
    get: function () {
      return this._image;
    },
    enumerable: false,
    configurable: true
  });

  ImageLegend.prototype.url = function () {
    var url;

    if ((0, _utils.isPlainObject)(this.opts.url)) {
      var key = this.opts.metric ? 'metric' : 'imperial';
      url = url[key];
    } else if ((0, _utils.isString)(this.opts.url)) {
      url = this.opts.url;
    }

    return url;
  };

  ImageLegend.prototype.getSize = function () {
    var size = _super.prototype.getSize.call(this);

    if (this._image) {
      size.width = Math.max(size.width, this._image.width);
    }

    return size;
  };
  /**
   * Resets the legend by removing all existing images.
   *
   * @memberof ImageLegend
   */


  ImageLegend.prototype.reset = function () {
    this.$el.empty();

    if (this._image) {
      this._image.onload = null;
    }

    this._image = null;
  };

  ImageLegend.prototype.update = function (opts, force) {
    if (force === void 0) {
      force = false;
    }

    if (!(0, _utils.isEmpty)(opts)) force = true;

    if (force || !this._image) {
      this._load(this.url());
    }
  };

  return ImageLegend;
}(_Legend.default);

var _default = ImageLegend;
exports.default = _default;
module.exports = exports.default;